import { Link } from 'react-router-dom';
import { TBaseTagContext } from '../types';
import { TTag } from './types';
import UniversalChildren from '../../UniversalTag/UniversalChildren';
import { omit } from 'lodash';
import React, { useMemo } from 'react';
import { validate } from '@krugom/validator';

export const CustomLink: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const validationScheme = useMemo(
    () => ({
      type: 'object',
      properties: {
        to: {
          type: 'string',
          required: true,
        },
      },
    }),
    []
  );

  const result = useMemo(() => validate(tagProps, validationScheme), [tagProps, validationScheme]);

  const filteredProps = useMemo(() => omit(tagProps, ['tag', 'schema']) as TTag, []);

  if (!result.isValid) {
    console.error('Тэг: $Link;', `Путь: ${context.path?.join('.') || 'Не указан'};`, result.errors);
    return <UniversalChildren context={context}>{tagProps.children}</UniversalChildren>;
  }

  return <Link {...filteredProps}><UniversalChildren context={context}>{tagProps.children}</UniversalChildren></Link>;
});

CustomLink.displayName = 'CustomLink';
